import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
  OnChanges,
} from '@angular/core';
import { EnrichedCashbackFormData } from '@features/cashback/types';
import { CurrencyService } from '@rd/core/services/currency/currency.service';
import { LoyaltyCurrencyService } from '@rd/core/services/loyalty-currency/loyalty-currency.service';
import { NumberService } from '@rd/core/services/number/number.service';
import { CASH_NUMBER_DIGITS_INFO } from '@rd/core/tokens/rd-lib.token';
import { LoyaltyProgram } from '@rd/types';
import { Promocode } from '@rd/types/promocode.type';

@Component({
  selector: 'rd-rcv2-review-breakdown',
  templateUrl: './review-breakdown.component.html',
  styleUrls: ['./review-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RcV2ReviewBreakdownComponent implements OnChanges {
  @HostBinding('class.rd-rcv2-review-breakdown') componentClass = true;
  @Input() formData: EnrichedCashbackFormData;
  @Input() promocode: Promocode | null;
  @Input() redeemCashLoyaltyProgram: LoyaltyProgram;

  hasDiscount = false;

  constructor(
    private loyaltyCurrencyService: LoyaltyCurrencyService,
    private numberService: NumberService,
    private currencyService: CurrencyService,
    @Inject(CASH_NUMBER_DIGITS_INFO) private digitsInfo: string,
  ) {}

  ngOnChanges(): void {
    this.hasDiscount =
      !!this.promocode &&
      this.formData.sourceAmountPaid != null &&
      this.formData.sourceAmountPaid < this.formData.sourceAmount;
  }

  sourceAmountString(amount: number): string {
    const sourceAmountParams = this.sourceAmountParams(amount);

    return `${sourceAmountParams.points_amount} ${sourceAmountParams.currency}`;
  }

  sourceAmountParams(sourceAmount: number): {
    points_amount: string;
    currency: string;
  } {
    return {
      points_amount: this.numberService.formatNumber(sourceAmount),
      // @ts-ignore
      currency: this.loyaltyCurrencyService.loyaltyCurrencySelected.name,
    };
  }

  formattedDestinationAmount(): string {
    return this.currencyService.formatCurrency(
      this.formData.targetAmount,
      'symbol',
      this.digitsInfo,
      this.redeemCashLoyaltyProgram?.loyaltyCurrency?.shortName,
    );
  }

  formattedDestinationAmountParams(): {
    amount: string;
    loyaltyCurrency?: string;
  } {
    return {
      amount: this.formattedDestinationAmount(),
      loyaltyCurrency: this.redeemCashLoyaltyProgram.shortName,
    };
  }
}
